import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Table } from 'react-bootstrap';


const DataLoggerBriefScreen = () => {

    const [dataLoggerBrief, setDataLoggerBrief] = useState([]);
    const loginState = useSelector(state => state.currentLogin);

    useEffect(() => {

        const getDataLoggerBrief = async () => {
            await axios.get('/dataLogger/listDataLoggerLocationBrief', { headers: { Authorization: loginState.token} })
            .then(response => {
                //console.log('>>> DataLoggerLocationBrief: ', response.data);
                setDataLoggerBrief(response.data);
            })
            .catch(error => {
                console.log('[Error] DataLoggerLocationBrief: ', error.message);
                if(error.response.status === 401){  //If Error 401 means user is not authorised
                    console.log('{*********} Error 401');
                }
                if(error.response.status === 403){  //If Error 403 means user is not authorised or Token has expired, route back to login screen...
                    console.log('{*********} Error 403 found - Logging out User...');
                }
            });
        }
        getDataLoggerBrief();
    }, [loginState]);

    return(
        <div className="container-fluid" style={{ marginTop: 20 }}>
            <Table responsive="md" striped bordered hover>
            <thead>
                <tr>
                    <th>Site Name</th>
                    <th>Timestamp</th>
                    <th>DataLoggerId</th>
                    <th>Latitude</th>
                    <th>Longitude</th>
                    <th>Temperature</th>
                    <th>Temp</th>
                    <th>Sensor Temp.</th>
                    <th>DO.</th>
                    <th>O2~</th>
                    <th>PH</th>
                    <th>Salinity</th>
                </tr>
            </thead>
            <tbody>
            {dataLoggerBrief.map(item => (
                <tr key={item.timestamp}>
                    <td>{item.name}</td>
                    <td>{item.data_Logger_Id}</td>
                    <td>{item.timestamp}</td>
                    <td>{item.latitude}</td>
                    <td>{item.longitude}</td>
                    <td>{item.temperature}</td>
                    <td>{item.temp}</td>
                    <td>{item.sensor_Temperature}</td>
                    <td>{item.dissolved_Oxygen}</td>
                    <td>{item.oxygen_Reduction_Potential}</td>
                    <td>{item.ph}</td>
                    <td>{item.salinity}</td>
                </tr>
            ))}
            </tbody>
            </Table>
        </div>
    );

}
export default DataLoggerBriefScreen;
